import React, {Component} from 'react';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { message } from 'antd';
import { POOL_DATA } from "./utils/config";

import {
  Route,
  NavLink,
  Link,
  withRouter,
  Switch
} from 'react-router-dom';

import withTracker from './withTracker';

import Home from './Containers/Home/Home';
import App from './Containers/App/App';
import iOS from './Containers/Support/components/iOS';
import Android from './Containers/Support/components/Android';
import QA from './Containers/Support/components/QA';
import Stores from './Containers/Stores/Stores';
import Feedback from './Containers/Support/components/Feedback';
import Login from './Containers/GetStarted/components/Login';
import Register from './Containers/GetStarted/components/Register';
import Forgot from './Containers/GetStarted/components/Forgot';
import Terms from './Containers/GetStarted/components/Terms';
import Policy from './Containers/GetStarted/components/Policy';
import Profile from './Containers/Profile/Profile';
import NoMatch from './Containers/NoMatch/NoMatch';

import logo from './logo.svg';
import menu from './menu.svg';
import './Frame.css';

class Frame extends Component {

  state= {
    display: 'none',
    login: false,
    mobile: false,
  };

  checkUserLogin = () => {
    const userPool = new CognitoUserPool(POOL_DATA);

    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          message.error(String(err));
          return;
        }
        if (session.isValid() === true) {
          this.setState({
            display: this.state.mobile ? 'block' : 'inline-block',
            login: true,
          })
        }
      });
    }
  };

  componentWillMount() {
    this.checkUserLogin();
  }

  componentWillReceiveProps() {
    this.checkUserLogin();
    window.scrollTo(0, 0);
  }

  handleLogout = () => {
    const userPool = new CognitoUserPool(POOL_DATA);

    const cognitoUser = userPool.getCurrentUser();
    try {
      cognitoUser.signOut();
      this.setState({
        display: 'none',
        login: false,
      });
      message.success('You\'ve successfully logged out');
      this.props.history.push('/');
    } catch(err) {
      message.error(String(err));
    }
  };

  handleActive = (match, location) => {
    return location.pathname ===  '/feedback' || location.pathname === '/support' || location.pathname === '/android-update' || location.pathname === '/ios-update';
  };

  handleChangeMenu = () => {
    this.setState({
      mobile: !this.state.mobile,
    })
  };

  handleClick = () => {
    this.setState({
      mobile: false,
    })
  };

  handleHidden = () => {
    if (this.state.mobile === true) {
      this.setState({
        mobile: false,
      })
    }
  };

  render() {

    return (
        <div className="Frame" onClick={this.handleHidden}>
          <div className="Header" id={this.state.mobile ? 'mobile' : ''}>
            <Link to="/" className="logo"><img src={logo} alt="Qbates" /></Link>
            <span>
              <ul>
                <li onClick={this.handleClick}><NavLink exact to="/" activeStyle={{ fontWeight: 700 }}>Quick Tour</NavLink></li>
                <li onClick={this.handleClick}><NavLink to="/app" activeStyle={{ fontWeight: 700 }}>Mobile Apps</NavLink></li>
                <li onClick={this.handleClick}><NavLink to="/stores" activeStyle={{ fontWeight: 700 }}>Stores</NavLink></li>
                <li onClick={this.handleClick}><NavLink to="/support" isActive={this.handleActive} activeStyle={{ fontWeight: 700 }}>Support</NavLink></li>
                <li onClick={this.handleClick} style={{ display: this.state.display }}><NavLink to="/profile" activeStyle={{ fontWeight: 700 }}>My Profile</NavLink></li>
              </ul>
              <button>{ this.state.login ? <a onClick={this.handleLogout}>LOG OUT</a> : <Link to="/login">GET STARTED</Link> }</button>
              <img src={menu} alt="Menu" onClick={this.handleChangeMenu}/>
            </span>
          </div>
          <div className="Content">
            <Switch history={this.props.history}>
              <Route exact path="/" component={withTracker(Home)}/>
              <Route path="/app" component={withTracker(App)}/>
              <Route path="/ios-update" component={withTracker(iOS)}/>
              <Route path="/android-update" component={withTracker(Android)}/>
              <Route path="/stores" component={withTracker(Stores)}/>
              <Route path="/support" component={withTracker(QA)}/>
              <Route path="/feedback" component={withTracker(Feedback)}/>
              <Route path="/login" component={withTracker(Login)}/>
              <Route path="/register" component={withTracker(Register)}/>
              <Route path="/forgot" component={withTracker(Forgot)}/>
              <Route path="/terms-of-use" component={withTracker(Terms)}/>
              <Route path="/policy-agreement" component={withTracker(Policy)}/>
              <Route path="/profile" component={withTracker(Profile)}/>
              <Route component={withTracker(NoMatch)}/>
            </Switch>
          </div>
          <div className="Footer">
            <p>All right reserved © Qbatesapp.com  2017-{new Date().getFullYear()}</p>
          </div>
        </div>
    )
  }
}

export default withRouter(Frame);



// WEBPACK FOOTER //
// ./src/Frame.js